import React, { useState, useContext, useEffect ,useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LoadingSkeleton from "../common/LoadingSkeleton";

import axios from "axios";
import PropertySideBar from './PropertySideBar';
import Listing from './Listing';
import FilterModal from '../modals/FilterModal';
import UrltoSlug from '../common/UrlToSlug';
import { decryptString, encryptString, generateShortKey } from '../../utils/cryptoUtil';
import { useLocation,useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
const PropertyListDemo = ({ url, subLocalities, user, prefix, cId, service,handleLocationId }) => {


   const navigate = useNavigate();
   const location = useLocation();
  const path = location.pathname;
  const pathSegments = path.split('/').filter(Boolean); // removes empty segments

  const [isDirectUrl,setIsDirectUrl] = useState(true);
  const [prefixCategory,setPrefixCategory] = useState(prefix);


  
  
  
  useEffect(() => {
    if (pathSegments.length === 0) {
      console.log('❌ Empty path');
      return;
    }

    const lastSegment = pathSegments[pathSegments.length - 1];

    // Pattern to check if last segment contains fixed keyword like -srlid-, -srslid-, -srcid-
    const slugPattern = /-(srlid|srslid|srcid)-\d+$/i;

    // Pattern to check if last segment is 18-character alphanumeric ID
    const is18CharID = /^[a-zA-Z0-9]{18}$/.test(lastSegment);

    if (slugPattern.test(lastSegment)) {
      console.log('✅ Matched: fixed keyword slug (srlid, srslid, srcid)');
    } else if (is18CharID) {
      console.log('✅ Matched: 18-character dynamic ID');
    } else {
    //  alert('❌ Unknown URL pattern');
     navigate("/not_found");
    }
  }, [path]);


  
  

    const [filters, setFilters] = useState({});
    const dispatch = useDispatch();
    const [paginationInfo, setPaginationInfo] = useState({
        currentPage: 1,
        lastPage: 1,
        total: 0,
    });


    const queryString = url.split("?")[1];

    
    const params = new URLSearchParams(queryString);
    const service1 = params.get("service");  // "sell"
    const category = params.get("category");

    //alert(category);

 




    // const [filters, setFilters] = useState({});
    const [list, setList] = useState([]);
    const [slugUrl, setSlugUrl] = useState('');
    const [loading, setLoading] = useState(true);
    const [isOpen, setIsOpen] = useState(false);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [updateUrl, setUpdateUrl] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);
    const [filterModal, setFilterModal] = useState(false);

    const handleFilterModalOpen = () => {
        setFilterModal(true);
    };
   

    const [isSidebar, setSidebar] = useState(false);

    //alert(JSON.stringify(list));
    const toggleAccordion = () => {
        setIsOpen(!isOpen); // Toggle the state on button click
    };
    //alert(selectedItems);
    const handleSelect = (label) => {
        setSelectedItems(label); // Set only one selected item at a time
    };
    const handleSidebarReady = () => {
        setSidebar(true);
    };



    useEffect(() => {
        const sortClicked = localStorage.getItem('sort_clicked');
        if (sortClicked) {
          const [key, value] = sortClicked.split(':');
          if (key === 'selectedItems') {
            handleSelect(value); // Now you call the function in the correct component
          }
      
          // Optional: clean up after reading
          localStorage.removeItem('sort_clicked');
        }
      }, []);
   

      const [slug,setSlug] = useState('');
    // Handle page change


    const handlePageChange = (newPage) => {
        if (newPage >= 1 && newPage <= paginationInfo.lastPage) {
            setPaginationInfo((prev) => ({ ...prev, currentPage: newPage }));
        }
    };
  
    const [selectedCheckboxes, setSelectedCheckboxes] = useState([]);

  const fetchPropertyData = async (cId, filtersArray = {}) => {
  setLoading(true);

   const con_url = new URL(window.location.href);
    const pathNameWith = con_url.pathname.split('/');
 let lastSegment = pathNameWith[pathNameWith.length - 1];

//         if(prefix == undefined)
//         {
//              const getRequestData = await axios.post(
//                 `${process.env.REACT_APP_BASE_URL}/shortIdToUrl`,
//                 {
//                   lastSegment
//                 }
//             );
//             if (getRequestData.data.status === 'success') {
//             console.log(getRequestData)
//             prefix = getRequestData.data?.data?.category
//             url=`${getRequestData.data?.data?.path}?${getRequestData.data?.data?.queryString}&prefix=${prefix}`
//               lastSegment = getRequestData.data?.data?.lastSegment;

//           //   setFilters(JSON.parse(getRequestData.data?.data?.filters))

         
//           }
//         }
//         else{
//            url=`${url}&prefix=${prefix}`;
//         }

  try {
    const response = await axios.post(
      `${process.env.REACT_APP_BASE_URL}/${url}&prefix=${prefixCategory}`,
      {
        lastSegment,
        filtersArray,
        selectedItems,
        updateUrl
      }
    );

    if (response.data.status === 'success') {

      setPrefixCategory(response.data?.data?.prefix);
      handleLocationId(response.data?.data?.locationId)
      if (
        !response.data?.data?.updateUrl &&
        response.data?.data?.filters &&
        isDirectUrl
      ) {
        setFilters(response.data.data.filters);

        const sorted =  Object.values(response.data.data.filters)
        .flatMap(val => val.split(','));
       
        setSelectedCheckboxes(sorted);
        setIsDirectUrl(false);
        return;
      }

      // alert(response.data.data.track);
      setSlugUrl(response.data.data.slug);
      setList(response.data.data.properties);
      setPaginationInfo({
        currentPage: response.data.data.current_page,
        lastPage: response.data.data.last_page,
        total: response.data.data.total,
      });

      setSlug(response.data.data.slug);
      setLoading(false);
      handleSidebarReady();
      setUpdateUrl(false);
    } else {
      setList([]);
      setLoading(false);
    }
  } catch (error) {
    console.error("Error fetching data:", error);

    // 🔔 Alert on 404 error
    if (error.response && error.response.status === 404) {
      // alert("No Page Found (404)");
       navigate("/not_found");
    }

    setList([]);
    setLoading(false);
  }
};
  
   // Trigger data fetch when the component mounts or when cId or currentPage changes
    useEffect(() => {
        if (isSidebar) {
            fetchPropertyData(cId, filters, selectedItems);
        }
     }, [isSidebar,filters,selectedItems]);


    const serviceMapping = {
        buy: 'Flats for Sale',
        rent: 'Flats for Rent',
        plot: 'Residential Plots for Sale',
        commerciallease: 'Commercial Property for Lease ',
        commercialbuy: 'Commercial Property for Sale'
    };


    const handleFilterReset = () => {
        setFilters([]);

    }

  
   
    useEffect(() => { 
        const fil = localStorage.getItem('feature_clicked');
      
        if (fil) {
          const fullArray = fil.split(',');

        
        //   const filtersArray = fullArray.split(':');
          // Extract only the values after ":"
        const filtersArray = fullArray.map(pair => {
        const [key, value] = pair.split(':'); // Split each "key:value" pair by ":"
        return value; // Return only the value after ":"
      });
  


     
          const newSelectedCheckboxes = filtersArray.map((value) => {
            return value; // Use only the value as the checkbox ID
          });
      
          setSelectedCheckboxes((prev) => Array.from(new Set([...prev, ...newSelectedCheckboxes])));
      
          // Optional: clear after applying
          localStorage.removeItem('feature_clicked');


          fullArray.forEach((item) => {
            const [key, value] = item.split(':');
            
            if (filters[key]) {
              // If key already exists, append value
              filters[key] = `${filters[key]},${value}`;
            } else {
              filters[key] = value;
            }
          });
        }
      }, []);


// useEffect(() => {


//    if (Object.keys(preDefineFilters).length === 0) 
//    {
//   fetchPropertyData(cId,filters)
//    }
//    else{
//  fetchPropertyData(cId,preDefineFilters)
//    }
// //   setSelectedCheckboxes(["apartment","east","plot","corner_plot"]);

 
 
// }, [preDefineFilters]);




      
      

    const handleFilterChange = (type, field, event) => {

      
        const isCheckbox = event?.target?.type === 'checkbox';
        const isChecked = event?.target?.checked ?? true;
        const checkboxId = `${type}`; // Same pattern you're using for checkbox IDs
      
        const replaceFields = ['price_range', 'area_range']; // Direct replace fields
      
        setFilters((prevFilters) => {
          let updatedFilters = { ...prevFilters };
      
          if (replaceFields.includes(field)) {
            // Direct replace field
            if (type) {
              updatedFilters[field] = type;
            } else {
              delete updatedFilters[field];
            }
          } else {
            // Handle multi-checkbox fields
            const currentValues = prevFilters[field]?.split(',').filter(Boolean) || [];
      
            if (isChecked) {
              if (!currentValues.includes(type)) {
                updatedFilters[field] = [...currentValues, type].join(',');
              }
            } else {
              const filteredValues = currentValues.filter((value) => value !== type);
              if (filteredValues.length > 0) {
                updatedFilters[field] = filteredValues.join(',');
              } else {
                delete updatedFilters[field];
              }
            }
          }


     
      setUpdateUrl(true);
          return updatedFilters;
        });
      
        // Update selectedCheckboxes only for checkboxes
        if (isCheckbox) {
          setSelectedCheckboxes((prev) => {
        
            if (isChecked) {
              return prev.includes(checkboxId) ? prev : [...prev, checkboxId];
            } else {
              return prev.filter((id) => id !== checkboxId);
            }
          });
        }

        console.log(selectedCheckboxes)
      };
      

    

    const sidebarRef = useRef(null); 

    // alert(project.property_price[0]);

  // Close sidebar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setFilterModal(false);
      }
    };

    // Add event listener
    document.addEventListener("mousedown", handleClickOutside);
    
    return () => {
      // Cleanup event listener on unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);



  


// const shortKeyRef = useRef(null);
// const [encryptedData, setEncryptedData] = useState("");
// const [decryptedData, setDecryptedData] = useState("");
 const mainPartRef = useRef();  // e.g., "buy/searches/flats-in"
//   const srlidRef = useRef();     // e.g., "srlid-3"
//   const urlLastPart = useRef();     // e.g., "srlid-3"

//   useEffect(() => {
//     const url = new URL(window.location.href);
//     const pathNameWith = url.pathname.split('/');
//     const pathNameWithoutLast = pathNameWith.slice(0, -1);
//     const lastSegment = pathNameWith[pathNameWith.length - 1]; // last segment string
//     const lastTwoParts = lastSegment.split('-').slice(-2);

//     mainPartRef.current = pathNameWithoutLast.join('/');   // "buy/searches/flats-in" (without trailing slash)
//     urlLastPart.current = lastTwoParts.join('-');             // "srlid-3"
//     srlidRef.current = lastSegment;  
// //    alert("Main Part:"+ mainPartRef.current);
// //     alert("SRLID:"+ srlidRef.current);


//   }, []);
  useEffect(() => {

     if (!slug ) return;
    const url = new URL(window.location.href);
    const pathNameWith = url.pathname.split('/');
    const pathNameWithoutLast = pathNameWith.slice(0, -1);
    const lastSegment = pathNameWith[pathNameWith.length - 1]; // last segment string
    const lastTwoParts = lastSegment.split('-').slice(-2);

    mainPartRef.current = pathNameWithoutLast.join('/');   // "buy/searches/flats-in" (without trailing slash)
    // urlLastPart.current = lastTwoParts.join('-');             // "srlid-3"
    // srlidRef.current = lastSegment;  
//    alert("Main Part:"+ mainPartRef.current);
//     alert("SRLID:"+ srlidRef.current);

const newUrl = `${mainPartRef.current}/${slug}`;
   window.history.replaceState({}, "", newUrl);

  }, [slug]);





// useEffect(() => {
//   if (!slug || !list ) return;

//   const filterValues = [];

//   Object.entries(filters).forEach(([key, value]) => {
//     const items = value.split(",");
//     items.forEach((item) => {
//       filterValues.push(item == 'apartment' ? 'flats' : item);
//     });
//   });

//   const combinedText = [...filterValues, slug].join(" ");

//   if (filterValues.length < 0) {
//     // shortKeyRef.current = null;
//     setEncryptedData("");
//   } else {
//     if (!shortKeyRef.current) {
//       shortKeyRef.current = generateShortKey(18);
//     }
//     const encrypted = encryptString(JSON.stringify(filters));
//     setEncryptedData(encrypted);
//   }

//   const timeout = setTimeout(() => {
//     const useShortKey = filterValues.length > 0 && !!shortKeyRef.current;
//     // const newSlug = useShortKey
//     //   ? shortKeyRef.current
//     //   : UrltoSlug(combinedText).replace(/^\//, "");

// let newSlug = '';

//       if(filterValues.length == 0)
//       {
//       newSlug=   srlidRef.current || "";
//       }
//       else{
//         newSlug =   shortKeyRef.current;
//       }
//     const newUrl = `${mainPartRef.current}/${newSlug}`;
//     window.history.replaceState({}, "", newUrl);
//   }, 100);

//   return () => clearTimeout(timeout);
// }, [slug, list, filters]);
// // Decrypt encrypted data whenever it changes
// useEffect(() => {
//   if (!encryptedData) {
//     setDecryptedData(null);
//     return;
//   }

//   try {
//     const decrypted = decryptString(encryptedData);
//     const parsed = JSON.parse(decrypted);
//     setDecryptedData(parsed);
//     console.log("Decrypted Data:", parsed);
//   } catch (error) {
//     console.error("Decryption failed:", error);
//   }
// }, [encryptedData]);


  function slugToTitle(slug) {
    if (!slug) return "";

    // Remove pid or any trailing identifier like pid-1
 let cleanSlug = slug.replace(/-(srcid|srslid|srlid)-\d+$/, '');

    // Split by hyphen, capitalize each word
    let words = cleanSlug.split("-").map((word) => {
      return word.charAt(0).toUpperCase() + word.slice(1);
    });

    // Join back and append brand name
    return words.join(" ") + " | Siddhi Ananta";
  }


    return (
        <>

              <Helmet>
                <title>{slugToTitle(slugUrl)}</title>
                <meta name="description" content={`Explore listings in ${slugToTitle(slugUrl)}. Find your dream property at Siddhi Ananta.`}  />
                <meta property="og:title" content={slugToTitle(slugUrl)} />
              </Helmet>
        
 <section   ref={sidebarRef} className={`filter-sidebar ${filterModal ? 'slide-in' : 'slide-out'}`}>

 <PropertySideBar
                className='mob'
                cId={cId}
                prefix={prefix}
                service={service}
                type={service1}
                category={category}
                filter={filters}
                handleSidebarReady={handleSidebarReady}
                handleFilterChange={handleFilterChange}
                handleFilterReset={handleFilterReset}
                selectedCheckboxes={selectedCheckboxes}
                // preDefineFilters={preDefineFilters}
            />
      </section> 
      
            <PropertySideBar
              className='desk property-filter'
                cId={cId}
                prefix={prefix}
                service={service}
                type={service1}
                category={category}
                filter={filters}
                handleSidebarReady={handleSidebarReady}
                handleFilterChange={handleFilterChange}
                handleFilterReset={handleFilterReset}
                selectedCheckboxes={selectedCheckboxes}
            />


    
            <div className="middleDiv propertymiddiv">

                <div className='property-section'>

                    <h4 className='mob text-center mb-4'>{serviceMapping[service] ?? 'Properties'} in {subLocalities?.name ?? ''}</h4>
                    <div className='d-flex justify-content-between gap-3' >
                        <div className='address-path desk d-flex justify-content-between w-100 '>
                            <div className="d-flex gap-2">
                                <span>Home</span>
                             

                                <span><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.4751 2.03996L7.7351 5.29996C8.1201 5.68496 8.1201 6.31496 7.7351 6.69996L4.4751 9.95996" stroke="#343434" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                </span>

                                <span>Jaipur</span>

                                <span><svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M4.4751 2.03996L7.7351 5.29996C8.1201 5.68496 8.1201 6.31496 7.7351 6.69996L4.4751 9.95996" stroke="#343434" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                </svg>
                                </span>


                                <span className='last-path'>
                                    {serviceMapping[service] ?? 'Properties'} in {subLocalities?.name ?? ''}
                                </span>
                                {/* <span className='last-path'>Flats for {service == 'buy' ? 'sale' : service} in {subLocalities?.name ?? ''}</span> */}
                            </div>

                            {/* <div className='pagination '>
                                Showing {((paginationInfo.currentPage - 1) * paginationInfo.perPage) + 1} - {Math.min(paginationInfo.currentPage * paginationInfo.perPage, paginationInfo.total)} of {paginationInfo.total}
                            </div> */}
                        </div>


                        <button class="btn filterButton mob" onClick={handleFilterModalOpen}>Filter</button>


                        <div className=" border-bottom-0 d-flex">

                            <div className="dropdown border-bottom-0" >
                                <div className="dropdown-toggle1 sortdd" onClick={toggleAccordion}>
                                    <span>Sort</span>
                                    <svg
                                        width="21"
                                        height="21"
                                        viewBox="0 0 21 21"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            d="M18.8024 6.63184H2.13574"
                                            stroke="#1C274C"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            d="M16.3024 10.7988H4.63574"
                                            stroke="#1C274C"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                        <path
                                            d="M13.8024 14.9658H7.13574"
                                            stroke="#1C274C"
                                            strokeWidth="1.5"
                                            strokeLinecap="round"
                                        />
                                    </svg>
                                </div>
                                {isOpen && (
                                    <div
                                        className="dropdown-menu-sort d-block position-absolute"
                                        data-aos="fade-up"
                                        data-aos-offset="200"
                                        data-aos-duration="200"
                                    >
                                        <div
                                            className={`menu-item menu_item ${selectedItems.includes("Relevance") ? "selected" : ""}`}
                                            onClick={() => handleSelect("Relevance")}
                                        >
                                            Relevance
                                        </div>

                                        <div
                                            className={`menu-item menu_item ${selectedItems.includes("Price Asc") ? "selected" : ""}`}
                                            onClick={() => handleSelect("Price Asc")}
                                        >
                                            <span>Price</span>
                                            <svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5 18V23" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                                <path d="M10 13V23" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                                <path d="M15 8L15 23" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                                <path d="M1 14.5C3.5 13.5 9.6 9.5 14 1.5M14 1.5L10.5 3.5M14 1.5V5" stroke="#343434" />
                                            </svg>
                                        </div>

                                        <div
                                            className={`menu-item menu_item ${selectedItems.includes("Price Desc") ? "selected" : ""}`}
                                            onClick={() => handleSelect("Price Desc")}
                                        >
                                            <span>Price</span>
                                            <svg width="16" height="23" viewBox="0 0 16 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11 17V22" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                                <path d="M6 12L6 22" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                                <path d="M1 7L1 22" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                                <path d="M1.35962 0.359374C2.35962 2.85937 6.35962 8.95937 14.3596 13.3594M14.3596 13.3594L12.3596 9.85937M14.3596 13.3594L10.8596 13.3594" stroke="#343434" />
                                            </svg>
                                        </div>

                                        <div
                                            className={`menu-item menu_item ${selectedItems.includes("Area Asc") ? "selected" : ""}`}
                                            onClick={() => handleSelect("Area Asc")}
                                        >
                                            <span>Area</span>
                                            <svg width="16" height="24" viewBox="0 0 16 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M5 18V23" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                                <path d="M10 13V23" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                                <path d="M15 8L15 23" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                                <path d="M1 14.5C3.5 13.5 9.6 9.5 14 1.5M14 1.5L10.5 3.5M14 1.5V5" stroke="#343434" />
                                            </svg>
                                        </div>

                                        <div
                                            className={`menu-item menu_item ${selectedItems.includes("Area Desc") ? "selected" : ""}`}
                                            onClick={() => handleSelect("Area Desc")}
                                        >
                                            <span>Area</span>
                                            <svg width="16" height="23" viewBox="0 0 16 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M11 17V22" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                                <path d="M6 12L6 22" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                                <path d="M1 7L1 22" stroke="#343434" strokeWidth="2" strokeLinecap="round" />
                                                <path d="M1.35962 0.359374C2.35962 2.85937 6.35962 8.95937 14.3596 13.3594M14.3596 13.3594L12.3596 9.85937M14.3596 13.3594L10.8596 13.3594" stroke="#343434" />
                                            </svg>
                                        </div>

                                        <div
                                            className={`menu-item menu_item ${selectedItems.includes("Last Updated") ? "selected" : ""}`}
                                            onClick={() => handleSelect("Last Updated")}
                                        >
                                            Last Updated
                                        </div>

                                        <div
                                            className={`menu-item menu_item_last ${selectedItems.includes("Date Added") ? "selected" : ""}`}
                                            onClick={() => handleSelect("Date Added")}
                                        >
                                            Date Added
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>



                    {loading ? <LoadingSkeleton /> :
                        <div className='main-area-contacted pt-2'>
                            <Listing user={user} service={service} list={list} />
                        </div>
                    }

                    {/* <div className="text-center m-3">
                        <button
                            className="btn btn-primary btn-sm m-2"
                            onClick={() => handlePageChange(paginationInfo.currentPage - 1)}
                            disabled={paginationInfo.currentPage === 1}
                        >
                            Previous
                        </button>
                        <span>
                            Page {paginationInfo.currentPage} of {paginationInfo.lastPage}
                        </span>
                        <button
                            className="btn btn-primary btn-sm m-2"
                            onClick={() => handlePageChange(paginationInfo.currentPage + 1)}
                            disabled={paginationInfo.currentPage === paginationInfo.lastPage}
                        >
                            Next
                        </button>
                    </div> */}


                </div>



            </div>
{/* 
            {filterModal &&
                // <FilterModal handleFilterModalClose={handleFilterModalClose} />
            } */}

        </>
    );
};

export default PropertyListDemo;
